<template>
    <div>
        <button
            class="flex items-center justify-between w-full px-3 py-3 font-semibold text-left text-sm text-gray-500 border-t border-gray-200 hover:bg-gray-100"
            :class="isActive ? 'bg-gray-50' : 'bg-white'"
            type="button"
            @click="toggleActive()"
        >
            <span class="text-black">{{ title }}</span>
            <icon :name="isActive ? 'arrow-drop-up-line' : 'arrow-drop-down-line'" size="34"></icon>
        </button>
        <div v-show="isActive">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
import { inject, computed } from "vue";

export default {
    name: 'live-designer-accordion',
    props: {
        title: {
            type: String,
            required: true
        }
    },
    setup(props) {
        // Inject accordion group controller if available
        const accordionGroup = inject('accordionGroup', null);
        
        // Computed property to check if this accordion is active
        const isActive = computed(() => {
            if (accordionGroup) {
                return accordionGroup.activeAccordion.value === props.title;
            }
            return false;
        });
        
        return {
            accordionGroup,
            isActive
        };
    },
    methods: {
        toggleActive() {
            if (this.accordionGroup) {
                if (this.isActive) {
                    this.accordionGroup.setActive(null);
                } else {
                    this.accordionGroup.setActive(this.title);
                }
            }
        },
    }
}
</script>
